import { render, staticRenderFns } from "./ProviderDetailOPPayableComponent.vue?vue&type=template&id=2d00a723&"
import script from "./ProviderDetailOPPayableComponent.vue?vue&type=script&lang=js&"
export * from "./ProviderDetailOPPayableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports